// src/services/presensiService.js
import axios from "axios";
import { ApiConfig } from "../constants/apiConfig";
import { studentHeaders } from "./apiClient";

export const kirimPresensiHadir = async () => {
  try {
    const now = new Date();
    const jam = now.toTimeString().split(" ")[0]; // "HH:MM:SS"

    const response = await axios.post(
      `${ApiConfig.baseUrl}/absensi`,
      {
        jam: jam,
        status: "hadir",
      },
      {
        headers: {
          ...studentHeaders(),
          Accept: "application/json",
        },
      }
    );

    // Jika response berhasil (200 atau 201)
    if (response.status === 200 || response.status === 201) {
      const data = response.data;
      return {
        success: true,
        message: data.message || "Presensi berhasil dikirim",
        data: data.data || null,
      };
    }

    // Jika bukan status sukses, fallback ke error
    return {
      success: false,
      message: response.data?.message || "Gagal melakukan presensi",
    };
  } catch (error) {
    // Jika error dari axios yang punya response (error validasi 400, 422, dll)
    if (error.response) {
      const data = error.response.data;
      if (data && data.message) {
        // Jika message berupa objek (validator errors)
        if (typeof data.message === "object") {
          let errors = [];
          for (const key in data.message) {
            if (data.message.hasOwnProperty(key)) {
              errors = errors.concat(data.message[key]);
            }
          }
          return {
            success: false,
            message: errors.join(", "),
          };
        }

        // Jika message berupa string
        return {
          success: false,
          message: data.message,
        };
      }

      // Jika tidak ada pesan error yang jelas
      return {
        success: false,
        message: "Gagal melakukan presensi (tidak ada pesan error detail)",
      };
    }

    // Jika error jaringan atau error lain
    return {
      success: false,
      message: `Terjadi kesalahan: ${error.message || error.toString()}`,
    };
  }
};
